import type {
  ConfirmProductImportInput,
  ProductImportPreview,
  ProductImportPreviewResponse,
} from '../../shared/productImport';
import type { WardrobeItem, WardrobeItemResponse } from '../../shared/wardrobe';
import { readError } from './api';

export async function previewProductImport(url: string): Promise<ProductImportPreview> {
  const response = await fetch('/api/product-imports/preview', {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ url }),
  });
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as ProductImportPreviewResponse).preview;
}

export async function confirmProductImport(
  input: ConfirmProductImportInput,
  requestKey: string,
): Promise<WardrobeItem> {
  const response = await fetch('/api/items/import', {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Idempotency-Key': requestKey,
    },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as WardrobeItemResponse).item;
}

export function importedImageUrl(previewId: string, imageUrl: string): string {
  return `/api/product-imports/${encodeURIComponent(previewId)}/image?url=${encodeURIComponent(
    imageUrl,
  )}`;
}
